import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { combineLatest, Observable } from 'rxjs';
import { take } from 'rxjs/operators'

import { Account } from 'graphql/models/generated';
import { AppArticle as Article } from 'graphql/models/extended';
import { Manufacturer } from 'models/account.model';
import { CoreDataService } from 'shared/services/core-data.service';
import { StoreService } from 'shared/services/store.service';

import { ArticleComponent } from '../article.component';
@Component({
  selector: 'app-article-modal',
  templateUrl: './article-modal.component.html',
  styleUrls: ['./article-modal.component.scss']
})
export class ArticleModalComponent implements OnInit {
  @ViewChild(ArticleComponent) articleComponent!: ArticleComponent;

  articleId!: string;

  manufacturer!: Manufacturer

  get form(): UntypedFormGroup {
    return this.articleComponent.form;
  }

  constructor(
    private coreDataService: CoreDataService,
    private storeService: StoreService
  ) { }

  ngOnInit(): void {
    this.init();
  }

  private init(): void {
    combineLatest([
      this.storeService.getCurrentArticle(),
      this.storeService.getAccount()
    ])
    .pipe(take(1))
    .subscribe(([article, account]: [Article, Account]) => {
      this.articleId = article.id || '';
      this.manufacturer = account.manufacturer as Manufacturer;
    });
  }

  onSubmit(): Observable<Article> {
    if (this.articleId) {
      return this.coreDataService.updateArticle(this.articleId, this.form.value, this.manufacturer);
    }

    return this.coreDataService.createArticle(this.form.value, this.manufacturer);
  }
}
